module.exports = __webpack_public_path__ + "media/images/wheel-2ffc2ad440bcfbfb688637fe63121a10.png";